module.exports = __webpack_public_path__ + "img/boots.55b7e3b1.svg";